<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> همایش ها و رخداد ها </span>

    </div>

</div>

<main class=" rtl py-3 px-2">

    <span *ngIf="list_Events.length > 0"> تعداد <span class="text-danger fw-bold">{{list_Events.length | faNum}}</span>
        مورد یافت شد </span>

    <div class="row gx-2 mt-1 border border-2 ">

        <div class="col-12 col-md-10 p-3">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div class="col-12 col-md-2 d-flex align-items-center">

            <button class="btn mx-2 px-5 w-100 btn-primary" (click)="openModal('Events')"> افزودن </button>

        </div>

        <div class="table-responsive" style="max-height: 76vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">

                        <th>#</th>

                        <th>عملیات</th>

                        <th> تصویر </th>

                        <th> تاریخ </th>

                        <th> عنوان </th>

                        <th> اسم مدرسه </th>

                        <th> تعداد لایک </th>

                        <th> تعداد کامنت </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Events;let i = index">

                        <th>{{ i + 1 | faNum }}</th>

                        <td class="col-1">

                            <i class="fa fa-pencil-square-o fa-lg  btn btn-primary" (click)="openModal('Events',item)" title="ویرابش"></i>

                            <i class="fa fa-picture-o fa-lg mt-2 btn btn-warning" title="گالری" (click)="getAlbums(item)"></i>

                            <i class="fa fa-commenting-o fa-lg mt-2 btn btn-secondary" (click)="showComment(item)"  title="نظرات"></i>

                            <i class="fa fa-trash-o fa-lg mt-2 btn btn-danger" (click)="deleteEvent(item)" title="حذف"></i>


                        </td>

                        <td>
                            <img class="rounded-circle" width="50" height="50"
                            src="{{item.strImage.trim() != '' ? 'data:image/jpeg;base64,' + item.strImage : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}"
                            [alt]="item.strName + item.strFamily"> 
                        
                        </td>

                        <td>{{item.strDate | faNum }}</td>

                        <td>{{item.strTitle }}</td>

                        <td>{{item.strMobileDomain_strComment }}</td>

                        <td>{{item.iLike | faNum }}</td>

                        <td>{{item.iComment | faNum }}</td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- Modal -->

<div class="modal fade" id="Events" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> {{editMode ? 'ویرایش' : 'افزودن' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeModal()"></button>

            </div>

            <form #form="ngForm" (ngSubmit)="newEvent(form)" class="modal-body rtl w-100 row gx-2 p-2">

                <div class="col-12">

                    <label> عنوان </label>

                    <input type="text" required [ngModel]="events.strTitle" name="strTitle" autocomplete="off"
                        class="form-control" />

                </div>

                <div class="col-12">

                    <label> توضیحات </label>

                    <textarea [ngModel]="events.strComment" required name="strComment" class="form-control"></textarea>

                </div>

                <div class="col-12 mt-2 text-end">

                    <button type="submit" [ngClass]="editMode ? '  btn-primary' : 'btn-success' " class="btn px-5">
                        {{editMode ? 'ویرایش' : 'ذخیره' }} </button>

                </div>

            </form>

            <div class="modal-footer"></div>


        </div>

    </div>

</div>

<div class="modal fade" id="comments" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> نظرات ( {{list_comments.length | faNum }} )</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>

            </div>

            <div class="modal-body ">

                <div *ngFor="let item of list_comments" class="border border-2 rounded rtl w-100 row gx-2 p-2 mb-2" style="max-height: 200px;overflow: auto;">

                    <span class="col-12 col-md-6"> نام و نام خانوادگی :  <strong>{{item.strPassenger_FullName}}</strong></span>

                    <span class="col-12 col-md-6 text-end mb-2"><strong>{{item.strFullDate | faNum}}</strong></span>

                    <p *ngIf="item.strComment != '' "> متن نظر :  {{item.strComment | faNum}}</p>


                </div>

            </div>

            <div class="modal-footer"></div>


        </div>

    </div>

</div>

<div dir="rtl" class="modal fade" id="gallery" tabindex="-1" aria-hidden="true" data-backdrop="false" data-bs-backdrop='static'>

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> گالری </h5>

                <button *ngIf="!showImage" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>

                <button *ngIf="showImage" type="button" class="btn-close" (click)="showImage = false;editAlbums=false"></button>

            </div>

            <div class="modal-body ">

                <div class="uploader-container" *ngIf="!showImage">

                    <span class="hidden-file">
    
                        <input type="file" #fileInput (change)="onFileInput($event.target.files[0])"/>
    
                    </span>
    
                    <div class="dropper-container" (click)="fileInput.click()">
    
                        <div class="drop-zone" ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)" [uploader]="uploader">
    
                            <img class="disbaled" style="width: 6rem;" src="../../../assets/Img/gallery.jpg">
    
                            <!-- <p> عکس مورد نظر را در این ناحیه رها کنید یا </p> -->
    
                            <div class="choose-btn mt-2">انتخاب فایل</div>
    
    
                        </div>
    
    
                    </div>
    
    
                </div>

                <div class="galleryContainer d-flex flex-wrap w-100 mt-2" *ngIf="!showImage">

                    <div class="galleryBox pointer rounded border border-2 mb-2  p-3 mx-1 "  *ngFor="let item of list_Albums">
    
                        <img class="w-100 h-100" style="object-fit: contain;" src="{{'data:image/jpeg;base64,'+ item.strImage}}" alt="{{item.strComment}}">
    
                        <div class="imageHover d-none show">
    
                            <div (click)="deletePicture(item)" class=" option_gallery p-2 mx-1"><i class="fa fa-trash" aria-hidden="true"></i> </div>
    
                            <div (click)="showImageGallery(item)" class=" option_gallery p-2 mx-1"> <i class="fa fa-eye" aria-hidden="true"></i> </div>
    
                            <div (click)="openEditMode(item)" class=" option_gallery p-2 mx-1"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> </div>
    
                        </div>
    
                    </div>
    
                </div>
    
                <div class="showImage w-100" *ngIf="showImage">
    
                    <img class="w-100 h-75" src="{{'data:image/jpeg;base64,'+ image_Data.strImage}}" alt="{{image_Data.strComment}}">
    
                    <div [ngClass]="editAlbums ? 'mt-3 position-relative' : 'disabled mt-3' ">

                        <label> توضیحات </label>
    
                        <textarea #textArea class="form-control w-100" name="strComment" [ngModel]="image_Data.strComment"></textarea>
        
                        <div *ngIf="editAlbums" class="edit-Image col-12 buttonContainer-save d-flex justify-content-end ">
                               
                            <button type="button" class="px-3  py-2 me-sm-2 text-white btn btn-primary"  (click)="editImage(textArea.value)"> ویرایش </button>
    
                        </div>
    
    
                    </div>
    
    
                </div>

            </div>

            <div class="modal-footer"></div>


        </div>

    </div>

</div>

<ng-container *ngIf="isLoading" >

    <div class="school_loading" style="z-index: 10000000088888888888888;">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>